module.exports = __webpack_public_path__ + "img/gameit.686980e4.jpg";